<div class="page-wrapper chiller-theme toggled">
  <main class="page-content">
    <div class="bgColor">
      <div class="container responsive-container">
        <div class="row header-row align-items-center" style="height: 4em;">
          <div class="col-8 col-md-6">
            <p class="appTitle">Foreign Courses</p>
          </div>
          <div class="col-4 col-md-6 text-end">
            <p class="adminName d-inline-block">
              {{ adminName }}
              <img
                width="36"
                height="36"
                style="margin-left: 0.5em;"
                src="assets/tenant-avatar.jpg"
                class="rounded-circle"
                alt="admin"
              />
            </p>
          </div>
        </div>

        <!-- search + add -->
        <div class="row my-3 align-items-center gx-2">
          <div class="col-12 col-md-6 mb-2 mb-md-0">
            <div class="search-wrapper position-relative">
              <input
                class="form-control search-input"
                (input)="onQuickFilterChanged($event.target.value)"
                type="text"
                placeholder="🔍 Search country or course..."
                [(ngModel)]="searchval"
                aria-label="Search country or course"
              />
              <button class="clear-btn" *ngIf="searchval" (click)="reset()" aria-label="Clear search">✖</button>
            </div>
          </div>

          <div class="col-12 col-md-3 text-md-end">
            <button class="btn addCourseBtn w-100 w-md-auto" (click)="openAdd()">
              <i class="fa fa-plus me-1" aria-hidden="true"></i>
              <span class="d-none d-sm-inline">Add Course</span>
              <span class="d-inline d-sm-none">Add</span>
            </button>
          </div>
        </div>

        <!-- grouped list -->
        <div *ngIf="grouped && grouped.length; else noData">
          <div *ngFor="let g of grouped" class="mb-3 group-card">
            <div
              class="group-header d-flex align-items-center justify-content-between border rounded p-2"
              (click)="toggleCountry(g)"
              [attr.aria-expanded]="g.expanded"
              role="button"
              tabindex="0"
            >
              <div class="country-title">
                <strong>{{ g.country_name }}</strong>
                <small class="text-muted"> ({{ g.courses?.length || 0 }})</small>
              </div>
              <div class="chev">
                <small class="text-muted">{{ g.expanded ? '▾' : '▸' }}</small>
              </div>
            </div>

            <div *ngIf="g.expanded" class="card p-2 courses-card">
              <ul class="mb-0 list-unstyled">
                <li *ngFor="let c of g.courses" class="py-1 d-flex justify-content-between align-items-center course-item">
                  <div class="course-info">
                    <div class="course-name">{{ c.course_name }}</div>
                    <small class="text-muted" *ngIf="c.additional_info">{{ c.additional_info }}</small>
                  </div>

                  <div class="ms-2">
                    <button
                      class="btn btn-sm btn-outline-danger delete-btn"
                      title="Delete course"
                      (click)="deleteCourse(c); $event.stopPropagation()"
                      [disabled]="deletingId === (c.course_id || c.id || c.courseId)"
                    >
                      <span *ngIf="deletingId !== (c.course_id || c.id || c.courseId)">
                        <i class="fa fa-trash" aria-hidden="true"></i>
                      </span>
                      <span *ngIf="deletingId === (c.course_id || c.id || c.courseId)">
                        Deleting...
                      </span>
                    </button>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <ng-template #noData>
          <div class="noData text-center py-4">
            <h4>Currently No Data Available!</h4>
          </div>
        </ng-template>

        <!-- Popup Modal -->
        <div class="backdrop" [ngStyle]="{ display: display }" (click)="onCloseHandled()"></div>
        <!-- <div class="modal" tabindex="-1" role="dialog" [ngStyle]="{ display: display }" aria-hidden="{{ display === 'none' }}">
           -->
          <div
  class="modal"
  tabindex="-1"
  role="dialog"
  [ngStyle]="{ display: display }"
  [attr.aria-hidden]="display === 'none'"
>

          <div class="modal-dialog" role="document">
            <div class="modal-content p-3">
              <div class="modal-header">
                <h5 class="modal-title">Add Course</h5>
                <button type="button" class="close btn btn-link" (click)="onCloseHandled()" aria-label="Close">
                  <span>&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <form [formGroup]="courseForm" (ngSubmit)="addCourse()">
                  <div class="mb-2">
                    <label>Select Country</label>
                    <select class="form-control" formControlName="country_id">
                      <option value="">-- Select Country --</option>
                      <option *ngFor="let c of countries" [value]="c.id">{{ c.country }}</option>
                    </select>
                    <div class="text-danger small" *ngIf="courseForm.get('country_id')?.touched && courseForm.get('country_id')?.invalid">
                      Country is required
                    </div>
                  </div>

                  <div class="mb-2">
                    <label>Course Name</label>
                    <input class="form-control" formControlName="course_name" placeholder="Course name" />
                    <div class="text-danger small" *ngIf="courseForm.get('course_name')?.touched && courseForm.get('course_name')?.invalid">
                      Course name is required
                    </div>
                  </div>

                  <div class="text-end">
                    <button type="button" class="btn btn-secondary me-2" (click)="onCloseHandled()">Cancel</button>
                    <button type="submit" class="btn btn-success">Add</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </main>
</div>
